(ns ycweb.util.comms
  (:require
   [taoensso.sente :as sente]
   [cemerick.url :as url]
   [ycweb.util.core :as u]
   [rum.core :as rum]
   [ajax.core :as ajax]
   [ajax.edn :as edn]
   #?@(:cljs
       [[cljs-time.core :as dt]
        [util.string :as str]]
       :clj
       [[clj-time.core :as dt]
        [util.string :as str]
        [util.core :as uc]])
   [ycweb.components.toaster :as toaster]))

(defonce ^:dynamic comms
  (atom {:open? false :listeners #{}}))

(defn load-deviceid []
  (let [uuid (u/get-local-storage :comms/local-id)
        new-uuid (if-not uuid (u/rand-uuid))]
    (when new-uuid
      (u/set-local-storage :comms/local-id new-uuid))
    (or uuid new-uuid)))

(def deviceid (memoize load-deviceid))

(defn clientid []
  (-> @comms :socket :state deref :uid))

(defn send [event message]
  (let [state @comms
        app-atom (:app-atom state)
        send-fn (:send-fn (:socket state))
        muuid (u/rand-uuid)]

    ;; Log all except version check events
    (when (and app-atom (not (#{:pos/version-check :pos/ping-check} event)))
      (println "Sending: " (pr-str event))
      (swap! app-atom assoc-in [:comms :sent] {:event event :uuid muuid :msg message}))

    (send-fn
      [event
       (assoc message :session-uuid (:session-uuid @app-atom) :comms/uuid muuid :comms/deviceid (deviceid))])
    {}))

(defmulti receive (fn [app-atom data] (:type (meta data))))

(defmethod receive :default [app-atom data]
  #?(:cljs (js/console.warn (str "Unhandled comms message: " (:type (meta data)) " --- " (pr-str data)))
     :clj (uc/info (str "Unhandled comms message: " (:type (meta data)) " --- " (pr-str data)))))

(defn comms-received []
  (do
    (swap! comms assoc :open? true)
    (swap! comms update :ping-check
      (fn [p]
        (->
          p
          (assoc :received (dt/now))
          (dissoc :warned :critical))))))

(defmethod receive :pos/ping-check [app-atom data]
  #?(:cljs
     (comms-received)))

(defn api-path [event api-key]
  #?(:cljs
     (when api-key
       (str "/api/" (str/replace (str/replace api-key #"web." "") #"\." "/")))
     :clj
     event))

(defn translate-send-namespaces [params]
  (cond
    (map? params)
    (into {}
      (for [[k v] params]
        [(if (namespace k)
           (keyword (str (namespace k) "." (name k)))
           k)
         (translate-send-namespaces v)]))

    (vector? params)
    (vec (map #(translate-send-namespaces %) params))

    :else
    params))

(defn ajax-call [method event message & [app-atom {:keys [manual-error-handler?]}]]
  (let [state @comms
        app-atom (or app-atom (:app-atom state))

        send-fn (get (:ajax state) method)

        api-key
        (try
          (if (namespace event)
            (str (namespace event) "/" (name event))
            (name event))
          #_(catch Exception e
              (.printStackTrace e)))

        api-path (api-path event api-key)]

    (when (and app-atom (not (#{:pos/version-check :pos/ping-check} event)))
      (swap! app-atom assoc-in [:comms :sent] {:event event :msg message}))

    (send-fn api-path
      (u/maybe assoc
        {:response-format (edn/edn-response-format)
         :format (edn/edn-request-format)
         :headers {:call-type "yc-api"}
         :keywords? true
         :handler
         (fn [response]
           (if (and (contains? response :success) (not (:success response)) (not manual-error-handler?))
             (receive app-atom
               (with-meta
                 {:message (:msg response)
                  :response/type (:response/type response)
                  :response/redirect (:response/redirect response)}
                 {:type :service/error}))

             (receive app-atom (with-meta response {:type event}))))
         :error-handler
         (fn [error]
           (let [response
                 (cond
                   (vector? (:response error))
                   (merge {} (:response error))

                   :else
                   (:response error))]

             (if manual-error-handler?
               (receive app-atom
                 (with-meta
                   {:msg (or (:msg response) (:message response) "Something went wrong")
                    :success false}
                   {:type event}))

               (receive app-atom
                 (with-meta
                   {:message (or (:msg response) (:message response) "Something went wrong")
                    :success false}
                   {:type :service/error})))))}
        :params
        (when (and message (not (empty? message)))
          (if (= method :get)
            (translate-send-namespaces message)
            message))))))

(defn ajax-get [event message]
  (ajax-call :get event message))

(defn ajax-post [event message]
  (ajax-call :post event message))

(defn ajax-put [event message]
  (ajax-call :put event message))

(declare restart-socket)

(defn check-ping [app-atom]
  (let [{:keys [started timeout received warned critical]} (:ping-check @comms)]
    (when started
      (cond
        (and
          (not warned)
          (> (dt/in-seconds (dt/interval started (dt/now))) (or timeout 25))
          (> (dt/in-seconds (dt/interval received (dt/now))) (or timeout 25)))
        (do
          (swap! comms assoc :open? false)
          (println "Comms warning, restart")
          (swap! comms assoc-in [:ping-check :warned] true)
          (toaster/open-toast app-atom :error "Connection lost, reconnecting..." {:closetime 2500})
          (restart-socket))

        (and (not critical) warned (> (dt/in-seconds (dt/interval received (dt/now))) 60))
        (do
          (swap! comms assoc :open? false)
          (println "Comms critical, request refresh")
          (swap! comms assoc-in [:ping-check :critical] true)
          (toaster/open-toast app-atom :error "Connection lost, please refresh." {:closetime 2500})))

      (swap! comms assoc-in [:ping-check :sent] (dt/now))
      (send :pos/ping-check {})

      #?(:cljs
         (js/setTimeout #(check-ping app-atom) 10000)))))

(defn update-pingcheck-state [app-atom]
  #?(:cljs
     (if (. js/document -hidden)
       (do
         (swap! comms assoc-in [:ping-check :timeout] 180))
       (do
         (send :pos/ping-check {})
         (swap! comms assoc-in [:ping-check :started] (dt/now))
         (swap! comms assoc-in [:ping-check :timeout] 25)))))

(defn start-ping-check [app-atom]
  #?(:cljs
     (do
       (.addEventListener js/document "visibilitychange" (partial update-pingcheck-state app-atom))
       (swap! comms assoc-in [:ping-check] {:started (dt/now) :timeout 25 :received (dt/now)})
       (js/setTimeout #(check-ping app-atom) 2000))))

(defn message-handler [state-atom {:as socket :keys [id ?data event]}]
  (let [[id ?data] (if (= id :chsk/recv) ?data [id ?data])]
    ;; We don't really care for these low-key, but periodic checks
    (when-not (#{:chsk/ws-ping :pos/version-check :pos/ping-check :chsk/state :chsk/handshake} id)
      (println "Received:" id)
      (swap! state-atom assoc-in [:comms :received] {:event id :uuid (:comms/uuid ?data) :msg ?data}))

    (comms-received)

    (receive state-atom (with-meta ?data {:type id :socket socket}))
    nil))

(defn setup-socket [url state-atom & [client-id]]
  (let [u (url/url url)
        {:keys [csrf-token]} @state-atom
        {:keys [chsk ch-recv send-fn state] :as socket}
        (sente/make-channel-socket! (:path u)
          csrf-token
          (merge
            (u/maybe assoc
              {:type :auto
               :backoff-ms-fn
               (fn [n]
                 (min 5164
                   (* n 574)))}
              :client-id client-id)
            (if (u/presence (:host u))
              {:host
               (if (and (:port u) (pos? (:port u))) (str (:host u) ":" (:port u)) (:host u))})))]

    (add-watch state :open?
      (fn [_ _ old new]
        (when (not= (:open? old) (:open? new))
          (swap! comms assoc :open? (:open? new)))))

    (swap! comms assoc
      :stop-fn (sente/start-chsk-router! ch-recv (partial #'message-handler state-atom))
      :socket socket
      :url url)
    socket))

(defn restart-socket []
  (println "Restarting websocket")
  (let [{:keys [url app-atom stop-fn socket]} @comms
        clientid (clientid)]
    (when stop-fn
      (swap! comms assoc :open? false)
      (println "stopping old socket")
      #?(:cljs
         (sente/chsk-disconnect! (:chsk socket)))
      (stop-fn))
    (remove-watch (:state socket) :open?)
    (setup-socket url app-atom clientid)))

(defn setup-local-identifier []
  (swap! comms assoc :deviceid (deviceid)))

(defn register-connection-listener [listener-fn]
  (swap! comms update :listeners conj listener-fn))

(defn fire-connection-listeners [app-atom open?]
  (doseq [listener (get-in @comms [:listeners])]
    (listener app-atom open?)))

(defn setup-websocket [endpoint app-atom connection-change-fn]
  (setup-local-identifier)
  (let [socket (setup-socket endpoint app-atom)]
    (start-ping-check app-atom)

    (add-watch (rum/cursor-in (:state socket) [:open?]) ::ws-open
      (fn [_ _ old new]
        (when (not= old new)
          (fire-connection-listeners app-atom new)
          (connection-change-fn new))))
    (swap! comms assoc :app-atom app-atom :open? (:open? @(:state socket)))))

(defn setup-ajax
  "Wires up the ajax transport. Pass `:fetch-start? false` when the mount was
   server-rendered — the :web/start payload is already in the page as
   data-state, so fetching it again is a wasted round-trip on every page."
  ([app-atom] (setup-ajax app-atom {}))
  ([app-atom {:keys [fetch-start?] :or {fetch-start? true}}]
   (swap! comms assoc
     :ajax
     {:get #'ajax/GET
      :post #'ajax/POST
      :put #'ajax/PUT}
     :app-atom app-atom
     :deviceid (deviceid))
   (when fetch-start?
     (ajax-get :web/start {}))))

(defn log [& l] (send :pos/log {:msg (apply str l)}))

(defmethod receive :chsk/handshake [app-atom data]
  #?(:cljs
     (comms-received)))